import { combineReducers } from "redux";

import { requestReducer as request } from "./requestReducer";

export const requestReducer = combineReducers({
  request,
});
